import type {PrismicDocument} from '@prismicio/types';
import {useHead} from '#imports';
import {safelyNavigateTo} from '@malt/utils';
import {buildHeadMetadata} from '~/composables/headMetadata';
import {useABTestSlices} from '~/composables/useABTestSlices';

type UsePrismicPageOptions = {
    head?: boolean;
};

export function usePrismicPage(document: PrismicDocument, options?: UsePrismicPageOptions) {
    const isRedirect = document.type === 'redirect';

    if (isRedirect) {
        safelyNavigateTo(document.data.redirectTo, {redirectCode: 301, externalToThisHost: true});
    }

    if (options?.head) {
        useHead(buildHeadMetadata(isRedirect ? undefined : document));
    }

    const {slices} = isRedirect ? {slices: []} : useABTestSlices(document);

    return {isRedirect, slices};
}
